<template>
    <app-framework>
        <template v-slot:title>
            <tw-divider color="white"
                        width="56"
                        class="mb-3"
            ></tw-divider>
            University of Cambridge
        </template>
        <overlay style="top: 0;" v-model="showVideoOverlay">
            <row align="center" class="h-full relative" justify="center">
                <video-player :play="showVideoOverlay"
                              :src="video.url"
                              class="absolute"
                              max-width="1000px"
                              v-if="video && video.url"
                ></video-player>
            </row>
        </overlay>
        <row>
            <column align="center" cols="full">
                <img src="@/assets/logos/cambridge_psychometrics.png" alt="cambridge logo" class="mb-10" width="450px">
<!--                <object :data="require('@/assets/logos/cambridge.svg')" class="mb-10" type="image/svg+xml"></object>-->
<!--                <tw-divider class="mb-5" color="primary" width="56"></tw-divider>-->
<!--                <div class="poppins-bold tracking-normal w-full text-center xs:text-3xl sm:text-5xl leading-higher mb-10">-->
<!--                    University of Cambridge-->
<!--                </div>-->
                <div
                    class="xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed text-center">
                    fitt Proudly partners with the University of Cambridge Psychometrics Centre.<br>This enables:
                </div>
                <row class="my-20">
                    <column :key="index"
                            class="px-5 mb-6"
                            lg="1/3"
                            md="1/2"
                            sm="full"
                            v-for="(item, index) in items"
                            xl="1/3"
                            xs="full"
                    >
                        <row :justify="innerWidth > 767 ? item.justify : 'start'" align="center" no-wrap>
                            <card
                                class="flex justify-center items-center z-10"
                                round style="min-width: 71px; max-width: 71px; min-height: 71px; max-height: 71px;"
                            >
                                <icon :icon="item.icon" color="primary"></icon>
                            </card>
                            <div class="ml-6 text-md tracking-normal xs:leading-snug sm:leading-relaxed">
                                {{ item.text }}
                            </div>
                        </row>
                    </column>
                </row>
                <div class="xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed text-center">
                    Candidates who successfully complete eligible
                    fitt journeys, receive certificates
                    of confirmation.
                </div>
                <row class="xs:mt-20 sm:mt-20 md:mt-32">
                    <column align="center" cols="full">
                        <tw-divider class="mb-5" color="primary" width="56"></tw-divider>
                        <div class="poppins-bold tracking-normal text-center xs:text-3xl sm:text-5xl leading-higher mb-10">
                            About the University of Cambridge
                        </div>
                        <div class="xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed text-center"
                             style="max-width: 1150px;"
                        >
                            The University of Cambridge (UK) is one of the world's most
                            prestigious institutions. It is continuously regarded as one
                            of the globe's best universities. Founded in 1209, it has
                            a rich legacy, spanning centuries. The Psychometrics Centre
                            is a multi-disciplinary institute of the University dedicated
                            to research, teaching and product development with a focus
                            on online environments. Learn more about the work of the
                            Centre here:
                        </div>
                        <tw-btn class="tracking-widest poppins-bold mt-16"
                                color="primary"
                                height="75" no-padding
                                outlined style="padding: 7px;"
                                width="278"
                                @click="playVideo()"
                                v-show="video"
                        >
                            <tw-btn color="primary" fab size="61">
                                <icon color="white" icon="play"></icon>
                            </tw-btn>
                            <div class="px-5 text-primary" style="font-size: 14px;">
                                PLAY VIDEO
                            </div>
                        </tw-btn>
                    </column>
                </row>
            </column>
        </row>
    </app-framework>
</template>

<script>
    import Helpers from "../mixins/Helpers";

    export default {
        name: "Cambridge",
        mixins: [Helpers],
        components: {
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
            // 'tw-divider': () => import('@/components/Divider.vue'),
            card: () => import('@/components/Card.vue'),
            icon: () => import('@/components/display/Icon.vue'),
            'tw-btn': () => import('@/components/Btn.vue'),
            'overlay': () => import('@/components/Overlay.vue'),
            'video-player': () => import('@/components/display/VideoPlayer.vue'),
        },
        data: () => ({
            innerWidth: 0,
            showVideoOverlay: false,
            video: null,
            items: [
                {
                    icon: 'check-all',
                    text: 'Scientific validation of the fitt platform in line with international best practice',
                    justify: 'end'
                },
                {
                    icon: 'chart-line-variant',
                    text: 'Positioning of the fitt platform as an intuitive career planning and learning journey',
                    justify: 'center'
                },
                {
                    icon: 'desktop-mac-dashboard',
                    text: 'Access to Cambridge psychometric tools and content on the platform',
                    justify: 'start'
                },
            ]
        }),
        methods: {
            playVideo() {
                this.showVideoOverlay = true;
            },
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
            },
            getVideo() {
                this.$contentful.getAsset('1d0tCRo1eGT4xMAcdpjfWf').then(
                    (asset) => {
                        this.video = asset.fields.file;
                    }
                );
            }
        },
        mounted() {
            window.addEventListener('resize', this.debounce(this.setInnerWidth, 500));
            this.setInnerWidth();
            this.getVideo();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style scoped>

</style>
